import React from 'react';
import { Link } from 'react-router-dom';
import partnerImg from '../assets/Partnerssmall.png';

const partnerTypes = [
  {
    type: 'Managed Service Providers',
    tag: 'MSP',
    desc: 'Add managed WiFi to your portfolio with zero capital investment. Sarvanta powers the backend — you own the customer relationship, deploy the hardware, and bill on your terms.',
    highlights: ['Recurring revenue model', 'Multi-tenant management portal', 'White-label options', 'Automated monitoring & alerts']
  },
  {
    type: 'Value Added Resellers',
    tag: 'VAR',
    desc: 'Bundle Sarvanta NaaS with open hardware access points and switches for turnkey enterprise wireless deals. No proprietary lock-in means better margins and happier customers.',
    highlights: ['Turnkey hardware + cloud bundles', 'Deal registration & protection', 'Pre-sales engineering support', 'Competitive partner pricing']
  },
  {
    type: 'System Integrators',
    tag: 'SI',
    desc: 'Deliver complex multi-site wireless deployments for hospitality chains, MDU developers, school districts, and warehouses. Our platform handles the cloud — you handle the rollout.',
    highlights: ['Multi-site deployment tools', 'Vertical-specific templates', 'API integration support', 'Project-based pricing']
  },
  {
    type: 'ISPs & Regional Telcos',
    tag: 'ISP',
    desc: 'You already own the WAN connection. Add managed WiFi as a natural upsell to your business customers. White-label the Sarvanta platform as your own managed WiFi offering.',
    highlights: ['White-label platform', 'Bulk device management', 'Service-tier provisioning', 'Usage analytics & reporting']
  }
];

const benefits = [
  { title: 'Competitive Margins', desc: 'Attractive partner pricing on both hardware and cloud subscriptions with growth-based incentives.' },
  { title: 'Partner Portal', desc: 'Dedicated multi-tenant dashboard to provision, monitor, and manage all your customer networks.' },
  { title: 'Sales & Technical Training', desc: 'Enablement programs to get your team certified on Sarvanta deployment and support.' },
  { title: 'Co-Marketing Support', desc: 'Co-branded collateral, case studies, and campaign resources to help you generate demand.' },
  { title: 'Pre-Sales Engineering', desc: 'Our solutions architects support your deals with site surveys, network design, and proof-of-concept deployments.' },
  { title: 'Deal Registration', desc: 'Protect your pipeline with deal registration. First to register gets pricing protection and dedicated support.' }
];

const Partners = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh' }}>

      {/* Hero */}
      <section style={{
        backgroundImage: `linear-gradient(135deg, rgba(0,5,3,0.88) 0%, rgba(10,22,40,0.85) 100%), url(${partnerImg})`,
        backgroundSize: 'cover', backgroundPosition: 'center',
        padding: '80px 40px', textAlign: 'center'
      }}>
        <h1 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '16px' }}>
          Grow Your Business with Sarvanta
        </h1>
        <p style={{ color: '#c4cdd8', fontSize: '1.15rem', maxWidth: '700px', margin: '0 auto 32px', lineHeight: '1.8' }}>
          Partner with us to deliver cloud-managed enterprise WiFi to your customers.
          Recurring revenue, open hardware, and a platform your team can sell, deploy, and support with confidence.
        </p>
        <Link to="/contact" style={{
          padding: '14px 32px', backgroundColor: '#2563eb', color: '#fff',
          borderRadius: '8px', textDecoration: 'none', fontWeight: '600', fontSize: '1rem'
        }}>Become a Partner</Link>
      </section>

      {/* Partner Types */}
      <section style={{ padding: '60px 40px', maxWidth: '1100px', margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', fontSize: '2rem', marginBottom: '16px' }}>Who We Partner With</h2>
        <p style={{ textAlign: 'center', color: '#a0aec0', maxWidth: '600px', margin: '0 auto 40px', lineHeight: '1.7' }}>
          Whether you manage networks, resell solutions, or deliver connectivity — there is a Sarvanta partnership model for you.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {partnerTypes.map((p, i) => (
            <div key={i} style={{
              padding: '32px', backgroundColor: '#0a1628', borderRadius: '12px',
              border: '1px solid #1a2744', display: 'flex', gap: '28px', flexWrap: 'wrap',
              alignItems: 'flex-start'
            }}>
              <div style={{ flex: '1 1 280px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                  <span style={{
                    padding: '4px 12px', backgroundColor: '#0f2847', borderRadius: '6px',
                    fontSize: '0.8rem', color: '#60a5fa', fontWeight: '700'
                  }}>{p.tag}</span>
                  <h3 style={{ fontSize: '1.2rem', margin: 0 }}>{p.type}</h3>
                </div>
                <p style={{ color: '#a0aec0', lineHeight: '1.7', fontSize: '0.95rem', margin: 0 }}>{p.desc}</p>
              </div>
              <div style={{ flex: '1 1 200px' }}>
                <ul style={{ color: '#93c5fd', fontSize: '0.9rem', lineHeight: '2', paddingLeft: '18px', margin: 0 }}>
                  {p.highlights.map((h, j) => (
                    <li key={j}>{h}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Partner Benefits */}
      <section style={{ padding: '60px 40px', backgroundColor: '#0a1628' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', fontSize: '2rem', marginBottom: '40px' }}>What Partners Get</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px' }}>
            {benefits.map((b, i) => (
              <div key={i} style={{
                padding: '24px', backgroundColor: '#000503', borderRadius: '10px',
                border: '1px solid #1a2744'
              }}>
                <h3 style={{ fontSize: '1.05rem', marginBottom: '8px', color: '#60a5fa' }}>{b.title}</h3>
                <p style={{ color: '#a0aec0', lineHeight: '1.6', margin: 0, fontSize: '0.92rem' }}>{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Become a Partner CTA */}
      <section style={{ padding: '60px 40px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '16px' }}>Ready to Partner?</h2>
        <p style={{ color: '#a0aec0', maxWidth: '550px', margin: '0 auto 24px', lineHeight: '1.7' }}>
          Tell us about your business and we will connect you with our channel team
          to explore partnership opportunities.
        </p>
        <Link to="/contact" style={{
          padding: '14px 32px', backgroundColor: '#2563eb', color: '#fff',
          borderRadius: '8px', textDecoration: 'none', fontWeight: '600', fontSize: '1rem'
        }}>Become a Partner</Link>
      </section>
    </div>
  );
};

export default Partners;
